var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"count-btn",attrs:{"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.click}},[_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.realMsg))])])}
var staticRenderFns = []

export { render, staticRenderFns }